import state from './moduleAccountLevelState.js';
import mutations from './moduleAccountLevelMutations.js';
import actions from './moduleAccountLevelActions.js';
import getters from './moduleAccountLevelGetters.js';

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
